import { ITraceableError } from '@/interfaces/Error';
import { IInformative } from '@/interfaces/Informative';

import { EErrorType, EErrorOriginTransform, EErrorSeverity, EErrorExhibition, EErrorBlock } from '@/helpers/enums';

export default class TraceableError implements ITraceableError {
  public type: EErrorType = EErrorType.general;
  public code: string|number = 'default';
  public message?: string;
  public block?: EErrorBlock = EErrorBlock.none;
  public origin?: EErrorOriginTransform;
  public trigger?: string;
  public severity?: EErrorSeverity = EErrorSeverity.warning;
  public exhibition?: EErrorExhibition = EErrorExhibition.none;
  public visibility?: boolean = true;
  public createdAt?: string|Date = new Date().toUTCString();
  public informative?: IInformative;
  public isOtherPaymentMethodsEnabled?: boolean = false;

  constructor(traceableError: ITraceableError) {
    Object.assign(this, traceableError);
  }
}